import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from 'angular-bootstrap-md';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-sort-dialog',
  templateUrl: './sort-dialog.component.html',
  styleUrls: ['./sort-dialog.component.scss']
})
export class SortDialogComponent implements OnInit {
  action: Subject<any> = new Subject();
  // selectedSorting: any = 'desc';
  constructor(public modalRef: MDBModalRef,public fb: FormBuilder) { }
  registrationForm = this.fb.group({
    selectedSorting: ['', [Validators.required]]
  })
  ngOnInit() {
  }
  
  onSubmit() {
    console.log(this.registrationForm.value.selectedSorting);  
    sessionStorage.setItem('Sort', this.registrationForm.value.selectedSorting); 
    this.action.next('data');
  }

  onClose() {
    this.action.next('yes');
  }
}
